<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickDiscardChanges"
                >
                    Discard
                </v-btn>

                <v-btn
                    dark
                    text
                    @click="onClickSave"
                    :disabled="!is_valid"
                >
                    Schedule
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
            <m-text-field
                autofocus
                :hint=hint
                v-model="text"
                emoji
            />

            <m-edit-instant
                label="Send Time"
                v-model="send_time"
                v-on:input="onChangeSendTime"
                :timezone="this.$rc.$state.getPrimaryTimezone()"
            />

        </v-card-text>

    </v-card> 

</v-dialog>
</template>

<script>


export default
{
    props: {
        hint : {
            type: String,
            default: function() { return "Type or copy/paste your message here.  Use enter to add newlines.  Field will auto-grow to contain your content."; }
        },
    },

    data() {
        return {
            dialog: false,
            text: '',
            send_time: null,
            stored_message_id: null,
            with: null,
        }
    },

    methods: {

        showDialog(params)
        {
            this.text = params.text;
            this.send_time = params.send_time;
            this.stored_message_id = params.stored_message_id;
            this.with = params.with;

            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            // The dialog is showing...
            if ( this.is_valid )
            {
                this.dialog = false;
                next(false);
                return;
            }
        
            this.$rc.snackbar('You must either correct the errors or discard your changes.',1500);
            this.dialog = true;
            next(false);
        },

        onClickSave()
        {
            let params = {
                'text': this.text,
                'send_time': this.send_time,
                'stored_message_id': this.stored_message_id,
            };

            this.$emit('ok',params);

            this.closeDialog();
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

       

        onChangeSendTime()
        {
            if ( this.send_time < Date.now() )
            {
                this.$rc.alert('Can not schedule message in the past', "You can not schedule a send time to be in the past.");
                this.send_time = null;
                return;
            }

            let date = new Date(this.send_time);

            if ( date.getHours() < 6 || date.getHours() > 18 )
            {
                this.$rc.confirm(
                    'Unusual scheduled time',
                    'You have scheduled this message to go out earlier than 6:00 AM or after 7:00 PM.  Are you sure?',
                    [
                        {'text': 'Cancel', 'value': 'cancel'},
                        {'text': 'Send at this time', 'value': 'confirm'},
                    ],
                
                    (response) => {
                        if (response != 'confirm') 
                        {
                            this.send_time = null;
                            return;
                        }
                    }
                );
            }
        }
    },

    computed: {
        is_valid() 
        {
            if ( this.text == null ) return false;
            if ( (''+this.text).trim().length == 0 ) return false;
            if ( this.send_time == null ) return false;
            if ( this.send_time <= Date.now() ) return false;

            return true;
        },

        title()
        {
            if ( this.with == null || this.with.trim().length == 0 )
                return 'Schedule Message';
            
            return 'Schedule Message: '+this.with;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>